export function installAccountMenu(
  bar: HTMLElement,
  trigger: HTMLButtonElement,
): AbortController {
  const menu = bar.querySelector<HTMLElement>(".cloud-account-menu");
  if (menu === null) throw new Error("Cloud account menu is unavailable");

  const controller = new AbortController();
  const listenerOptions = { signal: controller.signal };

  function setOpen(open: boolean, returnFocus = false): void {
    trigger.setAttribute("aria-expanded", String(open));
    bar.toggleAttribute("data-menu-open", open);
    if (returnFocus) trigger.focus();
  }

  trigger.addEventListener(
    "click",
    () => setOpen(trigger.getAttribute("aria-expanded") !== "true"),
    listenerOptions,
  );
  menu.addEventListener(
    "click",
    (event) => {
      if (event.target instanceof Element && event.target.closest("button") !== null) {
        setOpen(false);
      }
    },
    listenerOptions,
  );
  document.addEventListener(
    "pointerdown",
    (event) => {
      if (event.target instanceof Node && !bar.contains(event.target)) setOpen(false);
    },
    listenerOptions,
  );
  document.addEventListener(
    "keydown",
    (event) => {
      if (event.key === "Escape" && trigger.getAttribute("aria-expanded") === "true") {
        setOpen(false, true);
      }
    },
    listenerOptions,
  );

  return controller;
}
